import React from "react";
import { ArrowRight, Plus, Save, Edit } from "lucide-react";
import QuestionEditor from "./QuestionEditor"; 

const StepThree = ({
  selectedTest,
  editingTestId,
  testName,
  isEditingTitle,
  editedTestName,
  handleEditTestName,
  handleSaveTestName,
  handleCancelEditName,
  setEditedTestName,
  handleCancel,
  handlePreviousStep,
  questions,
  handleAddQuestion,
  handleQuestionChange,
  handleDeleteQuestion,
  handleAddAnswer,
  handleRemoveAnswer,
  imageData,
  handleSaveTest,
  isLoading,
  formErrors, 
  testNameEditableInputRef, 
  getQuestionFormRef,       
}) => {

  if (isLoading && !questions.length && !editingTestId) { 
    return (
      <div className="training-loading-container">
        <div className="training-loading-spinner"></div>
        <p>טוען נתונים...</p>
      </div>
    );
  }
  
  return (
    <div className="training-step-content">
      {!!editingTestId && (
        <div className="training-back-button-container">
          <button 
            className="training-button training-button-secondary"
            onClick={handleCancel}
            type="button"
            style={{ marginBottom: '1rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}
          >
            <ArrowRight size={16} />
            חזרה לרשימת המבחנים
          </button>
        </div>
      )}
    
      <div className="training-test-title-section">
        {isEditingTitle ? (
          <div className="training-test-name-edit-container">
            <div className="training-field-label">שם המבחן</div>
            <input
              type="text"
              ref={testNameEditableInputRef} 
              className={`training-text-input ${formErrors?.testName ? 'input-error' : ''}`}
              placeholder="הכנס שם למבחן"
              value={editedTestName}
              onChange={(e) => setEditedTestName(e.target.value)}
              aria-invalid={!!formErrors?.testName}
              aria-describedby={formErrors?.testName ? "test-name-error-msg" : undefined}
            />
            {formErrors?.testName && <p id="test-name-error-msg" className="training-error-text">{formErrors.testName}</p>}
            <div className="training-test-name-actions">
              <button 
                className="training-button training-button-primary training-button-small"
                onClick={handleSaveTestName}
                disabled={isLoading}
                type="button"
              >
                <Save size={16} />
                שמור
              </button>
              <button 
                className="training-button training-button-secondary training-button-small"
                onClick={handleCancelEditName}
                disabled={isLoading}
                type="button"
              >
                ביטול
              </button>
            </div>
          </div>
        ) : (
          <div className="training-test-name-display">
            <div className="training-test-name-header">
              {!!editingTestId && (
                <button 
                  className="training-button training-button-secondary training-button-small edit-name-btn"
                  onClick={handleEditTestName}
                  title="ערוך שם מבחן"
                  type="button"
                >
                  <Edit size={16} />
                  <span className="button-text">ערוך שם</span>
                </button>
              )}
              <h3 id="test-name-display-title" className="training-text-input-creation">
                {testName}
              </h3>
            </div>
            {formErrors?.testName && !isEditingTitle && (
                <p className="training-error-text" style={{ marginTop: '-1rem', marginBottom: '1.5rem'}}> 
                    {/* Adjust margins if it's for the display mode error */}
                    {formErrors.testName}
                </p>
            )}
          </div>
        )}
      </div>

      <div className="training-questions-container">
        {questions.map((question, index) => {
          const questionRef = getQuestionFormRef(index);
          return (
            <QuestionEditor
              key={question.id || `question-editor-${index}`} 
              ref={questionRef} 
              question={question}
              index={index}
              onQuestionChange={handleQuestionChange}
              onDeleteQuestion={handleDeleteQuestion}
              onAddAnswer={handleAddAnswer}
              onRemoveAnswer={handleRemoveAnswer}
              imageData={imageData}
              disableDelete={questions.length <= 1}
              errors={formErrors?.questions?.[index] || {}} 
            />
          );
        })}
        
        <div className="training-add-question-container">
          <button
            className="training-button training-button-secondary"
            onClick={handleAddQuestion}
            type="button"
          >
            <Plus size={16} />
            הוסף שאלה
          </button>
        </div>
        
        <div className="training-buttons-container">
          {!editingTestId && (
            <button 
              className="training-button training-button-secondary"
              onClick={handlePreviousStep}
              type="button"
            >
              חזרה
            </button>
          )}
          <button
            className="training-button training-button-primary"
            onClick={handleSaveTest}
            type="button"
            disabled={isLoading}
          >
            <Save size={16} />
            {!!editingTestId ? 'עדכן מבחן' : 'שמור מבחן'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default StepThree;